const initialState = {
  status: "invalid",
};

function SettingReducer(state = initialState, action) {
  switch (action.type) {
    case "SETTING_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "SETTING_SUCCESS":
      return {
        ...state,
        status: "success",
        data: action.data,
      };
    case "SETTING_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    case "SETTING_RESET":
      return {
        ...state,
        status: "invalid",
      };
    default:
      return state;
  }
}

export default SettingReducer;
